import { IReportGroup } from "../../../../../reporting/interfaces/IReportGroup";
import { Machine } from "../../../models/machine";
import { MachineConfiguration } from "../../../models/machineConfiguration";
import { ProgressiveDefinition } from "../../../models/progressiveDefinition";

export class MachinesDetailViewController {
  static $inject = ["machine", "progressiveDefinitions", "reportGroup"];

  readonly currentConfiguration: MachineConfiguration;
  currentConfigurationExpanded: boolean = false;
  readonly currentConfigurationProgressive: ProgressiveDefinition | undefined;

  constructor(
    readonly machine: Machine,
    readonly progressiveDefinitions: ProgressiveDefinition[],
    readonly reportGroup: IReportGroup
  ) {
    this.currentConfiguration = machine?.Configs?.find(
      (c) => c.CurrentConfiguration
    )!;
    const progressiveDefinitionId =
      this.currentConfiguration?.ProgressiveDefinitionId;
    this.currentConfigurationProgressive = progressiveDefinitionId
      ? progressiveDefinitions.find((p) => p.Id == progressiveDefinitionId)
      : undefined;
  }
}
